export default "__VITE_ASSET__BeUQUyhI__"